<template>
	<b-modal
		no-close-on-backdrop
		no-close-on-esc
		:visible="value"
		@close="$emit('reset')"
		size="lg"
		body-class="position-static"
		hide-header
		centered
		@shown="modalShowed"

	>
		El servicio se actualizara al estado
		<strong>{{ changeServiceStatusLabel }}</strong>
		<hr />

		<b-form-group label="Seleccione la razon de cambio de estado">
			<b-overlay
				rounded
				opacity="0.6"
				spinner-small
				spinner-variant="primary"
				:show="loading"
			>
				<VueTreeList v-if="reasonsOptions" :model="reasonsOptions">
					<template v-slot:leafNameDisplay="slotProps">
						<span v-if="!slotProps.model.children">
							<b-form-checkbox
								v-model="reasonStatedId"
								:value="slotProps.model.id"
								:unchecked-value="null"
							>
								{{ slotProps.model.label }}
							</b-form-checkbox>
						</span>
						<span v-else>
							{{ slotProps.model.label }}
						</span>
					</template>
				</VueTreeList>
				<b-alert show variant="warning" v-if="notReason"
					>No se encontro ninguna razon de estado</b-alert
				>
			</b-overlay>
		</b-form-group>
		<hr class="my-3" />
		<section class="extranet-reason" v-if="requireExtranetData">
			<h5> <md-icon :icon="'sync'"></md-icon>Extranet <small class="text-danger">(Requerido) </small>  </h5>
			<label>Selecione una opcion:*</label>
			<b-form-select :options="extranetReasons" v-model="extranetReasonSelected"></b-form-select>
			<hr class="my-3" />
		</section>

		<b-form-group label="Registra una nota">
			<b-textarea v-model="changeStatusNote" />
		</b-form-group>
		<b-alert show variant="danger" class="mt-3" v-if="errorReason"
			>Debe seleccionar una razon de estado</b-alert
		>
		<template #modal-footer="{ close }">
			<b-button
				:disabled="changeStatusLoading"
				@click="close()"
				type="button"
				class="float-right"
			>
				Cancelar
			</b-button>
			<b-button
				:disabled="changeStatusLoading"
				@click="doChangeStatus"
				type="button"
				variant="primary"
				class="float-right"
			>
				<span v-if="!changeStatusLoading">Actualizar servicio</span>
				<span v-else><b-spinner small></b-spinner> Procesando...</span>
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import api from "@/api.js";
import { mapActions } from "vuex";
import { VueTreeList, Tree } from "vue-tree-list";
export default {
	components: {
		VueTreeList
	},
	props: {
		value: Boolean,
		modelId: Number,
		copyFromId: Number,
		status: String,
		serviceId: [Number, String]
	},
	data: () => ({
		changeStatusNote: "",
		changeStatusLoading: false,
		reasonsOptions: null,
		reasonStatedId: null,
		notReason: false,
		loading: false,
		errorReason: false,
		extranetReasonSelected:null,
		requireExtranetData:false,
		extranetReasons:[]
	}),
	computed: {
		changeServiceStatusLabel() {
			return this.$root.auxVars.transportServiceStatusOpts.find(
				aux => aux.value === this.status
			).text;
		},
		reasonStateActiveOpts() {
			return this.$root.auxVars.reasonStateActiveOpts;
		}
	},
	watch: {
		value(v) {
			if(v){
				this.loadReasonOptions()
			}
			//if (v) this.loadReasonOptions();
		}
	},
	methods: {
		...mapActions("reservation", ["_fetchModel", "_fetchNotes"]),

		async loadReasonOptions() {
			this.extranetReasonSelected = null
			this.reasonsOptions = null;
			this.notReason = false;
			this.reasonStatedId = null;
			this.loading = true;
			await this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["reasonStatesActive"]
			});
			const aux = JSON.parse(JSON.stringify(this.reasonStateActiveOpts.filter(({ toStatus }) => toStatus === this.status)));
			if (aux.length === 0) {
				this.notReason = true;
			} else {
				this.notReason = false;
				this.reasonsOptions = new Tree(
					this.map(aux)
				);
			}
			this.loading = false;
		},
		async fetchModel() {
			await this._fetchModel({
				context: this,
				modelId: this.modelId,
				copyFromId: this.copyFromId
			});
		},
		async fetchNotes() {
			await this._fetchNotes({ context: this, modelId: this.modelId });
		},
		map(arr) {
			return arr ? arr.map(this.fix) : null;
		},

		fix(item) {
			item.dragDisabled = true;
			item.addTreeNodeDisabled = true;
			item.addLeafNodeDisabled = true;
			item.editNodeDisabled = true;
			item.delNodeDisabled = true;
			if (item.children)
				return {
					...item,
					children: this.map(item.children)
				};
			delete item.children;
			return item;
		},
		doChangeStatus() {
			if (this.reasonsOptions && !this.reasonStatedId) {
				return (this.errorReason = true);
			}
			if(this.requireExtranetData && this.$root.isEmpty(this.extranetReasonSelected)){
				return (this.errorReason = true);
			}
			this.changeStatusLoading = true;
			api(this)
				.post(`/transport-services/change-status/${this.serviceId}`, {
					note: this.changeStatusNote,
					status: this.status,
					reasonStateId: this.reasonStatedId,
					extranetReason:this.extranetReasonSelected
				})
				.then(() => {
					this.$root.showAlert("Servicio actualizado con éxito");
					this.changeStatusNote = "";
					this.fetchModel();
					this.fetchNotes();
					this.$emit("reset");
					this.$root.$emit(
						"bv::refresh::table",
						"reservations-index-list"
					);
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.errorReason = false;
					this.changeStatusLoading = false;
				});
		},
		modalShowed(){
			console.log(this.status);
			this.requireExtranetData = false;
			if(this.status !=='canceled'){
				return;
			}
			this.loading= true;
			this.$root.api
			.get(`/transport-services/extranet-reasons/${this.serviceId}`,{params:{status:this.status}})
			.then((res) => {
				if(res.data.requireExtranetData){
					this.requireExtranetData = true;
					this.extranetReasons = res.data.data;
				}
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading = false;
			})
		}
	}
};
</script>

<style></style>
